import { createStorageDriver } from "@exonn/storage";
export const localStorageDriver = createStorageDriver(localStorage);
